
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"120","viewBox":"0 0 52.917 31.75","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M658.796 489.391l28.544-49.847 28.544-49.848 28.898 49.644 28.897 49.644-57.442.203z","transform":"matrix(.25028 0 0 .25665 -152.805 -96.936)","opacity":".99","fill":"#f5f5f5","stroke":"#e20613","stroke-width":"13.704","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.674 24.11c0-.71.049-.784.59-.892.325-.065 1.064-.55 1.642-1.079.897-.82 1.164-.96 1.827-.96.66 0 .91.13 1.674.869 1.645 1.591 2.318 1.633 3.696.23 1.435-1.463 2.545-1.511 3.826-.167.505.529 1.085.918 1.559 1.046.717.193.755.241.755.965v.761H18.674z"}})])
          )
        }
      }
    